import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
import uploadFile from '@/components/upload/uploadFile.vue';
export default {
  name: 'online_service_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      channel_qr_code: '',
      channel_service_hotline: '',
      rules: {
        after_click_function: [{
          required: true,
          message: '请选择组件点击后的功能',
          trigger: 'change'
        }],
        service_hotline_source: [{
          required: true,
          message: '请选择客服电话来源',
          trigger: 'change'
        }],
        service_hotline: [{
          required: true,
          message: '请输入客服电话',
          trigger: 'change'
        }, {
          pattern: /^[0-9]+-?[0-9]*$/,
          message: '请输入正确的号码',
          trigger: 'change'
        }],
        qr_code_source: [{
          required: true,
          message: '请选择在线客服二维码来源',
          trigger: 'change'
        }],
        qr_code: [{
          required: true,
          message: '请上传在线客服二维码图片',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    upload: function upload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url) {
      this.$set(this.value.config, 'qr_code', "".concat(this.$ossurl).concat(url));
    },
    deleteImg: function deleteImg() {
      var _this = this;
      if (!this.value.config.qr_code) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.qr_code = '';
      });
    }
  },
  created: function created() {
    var _this2 = this;
    var _ref = this.tabListFlat.find(function (i) {
        return i.key === _this2.value.key;
      }) || {},
      _ref$config_default_v = _ref.config_default_value,
      config_default_value = _ref$config_default_v === void 0 ? {} : _ref$config_default_v;
    var defaultValue = JSON.parse(JSON.stringify(config_default_value));
    this.channel_qr_code = defaultValue.channel_qr_code;
    this.channel_service_hotline = defaultValue.channel_service_hotline;
    delete defaultValue.channel_qr_code;
    delete defaultValue.channel_service_hotline;
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', defaultValue);
    }
  }
};